/**
 * Mirror of Dart `validators` package's `matches(str, pattern)` helper
 * (`validators-3.0.0/lib/validators.dart:62-65`):
 *
 *   bool matches(String str, pattern) {
 *     RegExp re = new RegExp(pattern);
 *     return re.hasMatch(str);
 *   }
 *
 * In JS: `new RegExp(pattern).test(str)`. Same semantics. Pattern can be a
 * raw character class like `'[0-9]'` or `'[@, _, !, $, %]'`. Used by the
 * 5-rule password validator (see `password-validation.ts`).
 */
export function matches(str: string, pattern: string): boolean {
  return new RegExp(pattern).test(str);
}
